import React from 'react';
import {FieldViewProps} from "../../../render/view";
import GDProjectName from "../../../../gd-ui/project-name/project-name";
import Event from "../../../../model2/event/event";

export default function FieldEvent_View(props:FieldViewProps) {

    const event = _.get(props.model, props.field.fieldId, null) as Event

    if (!event) return null

    const classes = Classes("flex-row-left-center ", "", props.className, {
        // 'invalid-value': !props.field.isValueValid(value)
    })

    return (
        <div className={classes}>
            <div className="i5-meeting ui5-ico-14 m-r-5"/>

            <span className="ui5-txt-default txt-truncate no-wrap">{event.name}</span>

            {event.projectId &&
                <GDProjectName className="m-l-10"
                               projectId={event.projectId}
                               type="ui5-prop"
                               hintFullPath={true} />
            }


        </div>
    );
}
